<!-- =========================================================================================
    File Name: Trend.vue
    Description: Price Optimization Trend
    ----------------------------------------------------------------------------------------
    Item Name: Appyvue - Bootstrap App with PY and VUE
    Author: @nand
========================================================================================== -->
<template>
  <div id="trend" class="mt-base">
    <!-- <pre>{{dashboard.competition}}</pre> -->
    <!-- <div v-if="!dashboard || (dashboard && !dashboard.overview)" class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
        <img src="@/assets/images/pages/not-authorized.png" alt="graphic-not-authorized" class="mx-auto mb-4">
        <h1 class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color">You are not authorized!</h1>
        <p class="sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text-inverse">paraphonic unassessable foramination Caulopteris worral Spirophyton encrimson esparcet aggerate chondrule restate whistler shallopy biosystematy area bertram plotting unstarting quarterstaff.</p>
        <vs-button size="large" to="/">Back to Home</vs-button>
    </div>-->
    <div
      v-if="dashboard.overview && dashboard.overview.trend && dashboard.overview.trend.length > 0"
    >
      <div class="vx-row">
        <div
          class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 cursor-pointer"
          @click="openStock()"
        >
          <statistics-card-line
            icon="HashIcon"
            :statistic="dashboard.overview.trend[0].data[dashboard.overview.trend[0].data.length -1]"
            :statisticTitle="dashboard.overview.trend[0].name"
            :chartData="[dashboard.overview.trend[0]]"
            type="area"
            hideChart
            icon-right
            class="mb-2"
          ></statistics-card-line>
        </div>
        <div 
          class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 cursor-pointer"
          @click="priceGapDetail('all')">
          <statistics-card-line
            :statistic="dashboard.overview.trend[1].data[dashboard.overview.trend[1].data.length -1]"
            :statisticTitle="dashboard.overview.trend[1].name"
            :chartData="[dashboard.overview.trend[1]]"
            icon="SearchIcon"
            color="primary"
            type="area"
            hideChart
            icon-right
            class="mb-2"
          ></statistics-card-line>
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            icon="ThumbsUpIcon"
            :statistic="dashboard.overview.trend[3].data[dashboard.overview.trend[3].data.length -1] ? 
            dashboard.overview.trend[3].data[dashboard.overview.trend[3].data.length -1] : '-'"
            :statisticTitle="dashboard.overview.trend[3].name"
            :chartData="[dashboard.overview.trend[3]]"
            color="warning"
            type="area"
            hideChart
            icon-right
            class="mb-2"
          ></statistics-card-line>
        </div>
        <!-- <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 cursor-pointer"
          @click="openInsight()"
        > -->
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4"
        >
          <statistics-card-line
            icon="BellIcon"
            :statistic="dashboard.competition.length"
            statisticTitle="Competitors"
            :chartData="[dashboard.overview.trend[5]]"
            color="danger"
            type="area"
            hideChart
            icon-right
            class="mb-2"
          ></statistics-card-line>
          <!-- <statistics-card-line
            icon="EyeIcon"
            :statistic="dashboard.overview.trend[5].data[dashboard.overview.trend[5].data.length -1]/100 | numFormat('0.00 %')"
            :statisticTitle="dashboard.overview.trend[5].name"
            :chartData="[dashboard.overview.trend[5]]"
            color="success"
            type="area"
            hideChart
            icon-right
            class="mb-2"
          ></statistics-card-line> -->
        </div>
      </div>
      <div class="vx-row" v-if="false">
        <div
          class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            icon="BriefcaseIcon"
            statistic="-"
            statisticTitle="Departments"
            :chartData="[dashboard.overview.trend[0]]"
            type="area"
            hideChart
            icon-right
            class="mb-base"
          ></statistics-card-line>
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            statistic="-"
            statisticTitle="Categories"
            :chartData="[dashboard.overview.trend[1]]"
            icon="GridIcon"
            color="primary"
            type="area"
            hideChart
            icon-right
            class="mb-base"
          ></statistics-card-line>
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            icon="ArrowDownIcon"
            statistic="-"
            statisticTitle="Priced Low"
            :chartData="[dashboard.overview.trend[2]]"
            color="success"
            type="area"
            hideChart
            icon-right
            class="mb-base"
          ></statistics-card-line>
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            icon="ArrowUpIcon"
            statistic="-"
            statisticTitle="Priced High"
            :chartData="[dashboard.overview.trend[5]]"
            color="danger"
            type="area"
            hideChart
            icon-right
            class=""
          ></statistics-card-line>
          <!-- <statistics-card-line
            icon="EyeIcon"
            :statistic="dashboard.overview.trend[5].data[dashboard.overview.trend[5].data.length -1]/100 | numFormat('0.00 %')"
            :statisticTitle="dashboard.overview.trend[5].name"
            :chartData="[dashboard.overview.trend[5]]"
            color="success"
            type="area"
            hideChart
            icon-right
            class="mb-base"
          ></statistics-card-line> -->
        </div>
      </div>


      <div class="vx-row" v-if="dashboard.delta && dashboard.delta.hpriced">
        <div class="vx-col w-full mt-base">
          <vx-card title="Price Gap analysis">
            <template slot="actions">
              <feather-icon icon="FilterIcon" @click="openStock('item-list-view')"></feather-icon>
            </template>
            <div slot="no-body" class="p-6 pb-0 mb-4">
              <div class="vx-row">
                <div
                  class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4 cursor-pointer"
                  @click="priceGapDetail('high')"
                >
                  <statistics-card-line
                    icon="TrendingUpIcon"
                    :statistic="dashboard.delta.hpriced | numFormat"
                    statisticTitle="# Highest"
                    hideChart
                    icon-right
                    color="danger"
                  ></statistics-card-line>
                </div>
                <div
                  class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4 cursor-pointer"
                  @click="priceGapDetail('higher_only')"
                >
                  <statistics-card-line
                    icon="ArrowUpIcon"
                    :statistic="getPricedSKUs('higher_only', dashboard.delta.hpriced, dashboard.delta.lpriced) | numFormat"
                    statisticTitle="# Higher w/o Highest"
                    hideChart
                    icon-right
                    color="warning"
                  ></statistics-card-line>
                </div>
                <div
                  class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4 cursor-pointer"
                  @click="priceGapDetail('higher_plus')"
                >
                  <statistics-card-line
                    icon="ArrowUpIcon"
                    :statistic="getPricedSKUs('higher_plus', dashboard.delta.hpriced, dashboard.delta.lpriced) | numFormat"
                    statisticTitle="# Higher + Highest"
                    hideChart
                    icon-right
                    color="danger"
                  ></statistics-card-line>
                </div>
                <div
                  class="vx-col w-full sm:w-1/4 md:w-1/4 lg:w-1/4 xl:w-1/4 cursor-pointer"
                  @click="priceGapDetail('low')"
                >
                  <statistics-card-line
                    icon="TrendingDownIcon"
                    :statistic="dashboard.delta.lpriced | numFormat"
                    statisticTitle="# SKUs Priced the Lowest"
                    hideChart
                    icon-right
                    color="success"
                  ></statistics-card-line>
                </div>
              </div>
              <vs-alert
                active="false"
                :color="colors.alert"
                class="mt-3 mb-3"
                icon-pack="feather"
                icon="icon-alert-triangle"
              >
                <p>Click on the above cards to view and download data<p/>
                <p>Click on the numbers below to drilldown to the specific filtered view</p>
              </vs-alert>
            </div>
            <div slot="no-body" class="p-6 mb-4">
              <vs-table stripe :data="deltaShareTranspose">
                <template slot="thead">
                  <vs-th>Price Difference ( Delta Range )</vs-th>
                  <vs-th :data="th"
                    :key="indexth"
                    v-for="(th, indexth) in deltaShareTranspose.label">{{th}}</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr>
                    <vs-td>
                      # SKUs Priced High
                      <vs-button  type="flat" icon-pack="feather" icon="icon-trending-up" size="small" color="danger">with respect to Next Highest Price</vs-button>
                    </vs-td>
                    <vs-td
                      class="cursor-pointer" 
                      :key="indextd"
                      v-for="(td, indextd) in data.high"
                    >
                      <div @click="openStockNew('item-list-view', {tag: deltaShareTranspose.label[indextd].trim().replace('%', '').toLowerCase(), mode: 'high'})">
                        <span>{{td}}</span>
                        <vs-progress
                          :percent="td"
                          color="danger"
                        ></vs-progress>
                      </div>                    
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      # SKUs Priced High
                      <vs-button  type="flat" icon-pack="feather" icon="icon-trending-up" size="small" color="danger">with respect to Avg. Market Price</vs-button>
                    </vs-td>
                    <vs-td  
                      class="cursor-pointer"
                      :key="indextd"
                      v-for="(td, indextd) in data.hamp"
                    >
                      <div @click="openStockNew('item-list-view', {tag: deltaShareTranspose.label[indextd].trim().replace('%', '').toLowerCase(), mode: 'hamp'})">
                        <span>{{td}}</span>
                        <vs-progress
                          :percent="td"
                          color="danger"
                        ></vs-progress>
                      </div>                    
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      # SKUs Priced Low
                      <vs-button  type="flat" icon-pack="feather" icon="icon-trending-down" size="small" color="success">with respect to Next Lowest Price</vs-button>
                    </vs-td>
                    <vs-td 
                      class="cursor-pointer"
                      :key="indextd"
                      v-for="(td, indextd) in data.low"
                    >
                      <div @click="openStockNew('item-list-view', {tag: deltaShareTranspose.label[indextd].trim().replace('%', '').toLowerCase(), mode: 'low'})">
                        <span>{{td}}</span>
                        <vs-progress
                          :percent="td"
                          color="success"
                        ></vs-progress>
                      </div>                    
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      # SKUs Priced Low
                      <vs-button  type="flat" icon-pack="feather" icon="icon-trending-down" size="small" color="success">with respect to Avg. Market Price</vs-button>
                    </vs-td>
                    <vs-td 
                      class="cursor-pointer"
                      :key="indextd"
                      v-for="(td, indextd) in data.lamp"
                    > 
                      <div @click="openStockNew('item-list-view', {tag: deltaShareTranspose.label[indextd].trim().replace('%', '').toLowerCase(), mode: 'lamp'})">
                        <span>{{td}}</span>
                        <vs-progress
                          :percent="td"
                          color="success"
                        ></vs-progress>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>
        </div>
      </div>

      <vs-alert
        active="true"
        :color="'primary'"
        class="mt-3 mb-3"
        icon-pack="feather"
        icon="icon-activity"
      >
        <strong>Assortment Analysis</strong>
      </vs-alert>
      
      <div class="vx-row">
        <div class="vx-col w-full mb-3">
          <vx-card title="Assortment match by Retailer">
            <template slot="actions">
              <feather-icon icon="GridIcon" @click="openStock()"></feather-icon>
            </template>
            <vue-apex-charts
              type="bar"
              height="330"
              :options="competeGraph.chartOptions"
              :series="competeGraph.series"
            />
          </vx-card>
        </div>
      </div>
<!-- 
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-base">
          <vx-card title="Realtime Competition Scan">
            <div id="chart1">
              <vue-apex-charts ref="realtimeChart" type=line height=230 :options="realtimeTrendChart.chartOptionsArea" :series="realtimeTrendChart.series" />
            </div>
            <div id="chart2">
              <vue-apex-charts ref="realtimeChart" type=area height=130 :options="realtimeTrendChart.chartOptionsBrush" :series="realtimeTrendChart.series" />
            </div>
          </vx-card>
          <vx-card title="Competition Discovery Tracker">
            <div class="vx-row flex-col-reverse lg:flex-row">
              <div class="vx-col w-full lg:w-1/2 xl:w-1/2 flex flex-col justify-between">
                <div class="mb-base">
                  <h2 class="mb-1 font-bold">{{ dashboard.scanner.queued | numFormat }}</h2>
                  <span class="font-medium">New SKUs</span>
                </div>
                <vue-apex-charts
                  type="bar"
                  height="80"
                  :options="analyticsData.salesBar.chartOptions"
                  :series="analyticsData.salesBar.series"
                  v-if="analyticsData.salesBar.series"
                />

                <vs-button
                  icon-pack="feather"
                  icon="icon-chevrons-right"
                  icon-after
                  class="shadow-md w-full mt-4"
                  @click="openStock()"
                >View SKUs</vs-button>
              </div>

              <div class="vx-col w-full lg:w-1/2 xl:w-1/2 flex flex-col lg:mb-0 mb-base">
                <change-time-duration-dropdown class="self-end" />
                <vue-apex-charts
                  type="bar"
                  height="200"
                  :options="analyticsData.salesBar.chartOptions"
                  :series="analyticsData.salesBar.series"
                  v-if="analyticsData.salesBar.series"
                />
                <vue-apex-charts type=radialBar height=200 :options="analyticsData.supportTrackerRadialBar.chartOptions" :series="[70]" />
                <vue-apex-charts
                  type="radialBar"
                  height="240"
                  :options="analyticsData.goalOverviewRadialBar.chartOptions"
                  :series="[dashboard.scanner.processed]"
                />
              </div>
            </div>

            <vs-divider class="my-6"></vs-divider>

            <div class="vx-row">
              <div class="vx-col w-1/2 mb-3">
                <small>In Progress: {{dashboard.scanner.inProgress | numFormat }}</small>
                <vs-progress
                  class="block mt-1"
                  :percent="(Number(dashboard.scanner.inProgress)/Number(dashboard.scanner.queued))*100"
                  color="primary"
                ></vs-progress>
              </div>
              <div class="vx-col w-1/2 mb-3">
                <small>Issues: {{dashboard.scanner.failed | numFormat }}</small>
                <vs-progress class="block mt-1" :percent="60" color="warning"></vs-progress>
              </div>
              <div class="vx-col w-1/2 mb-3">
                <small>InActive: {{dashboard.scanner.inActive | numFormat }}</small>
                <vs-progress class="block mt-1" :percent="70" color="danger"></vs-progress>
              </div>
              <div class="vx-col w-1/2 mb-3">
                <small>Live Competitors: {{6 | numFormat }}</small>
                <vs-progress class="block mt-1" :percent="(6/7)*100" color="success"></vs-progress>
              </div>
            </div>
          </vx-card>
        </div>
      </div> 
-->

      <div class="vx-row" v-if="prodDistLabels && prodDistLabels.length > 0">
        <div class="vx-col w-full mb-base">
          <vx-card title="Price distribution for matched assortment by Retailer">
            <template slot="actions">
              <feather-icon icon="FilterIcon" @click="openStock('item-list-view')"></feather-icon>
            </template>
            <vs-alert
              active="false"
              :color="colors.alert"
              class="mt-3 mb-3"
              icon-pack="feather"
              icon="icon-alert-triangle"
            >
              <p>Click on the bars below to drilldown to the specific filtered view</p>
            </vs-alert>
            <vue-apex-charts
              type="bar"
              height="330"
              :options="competeGraphStack.chartOptions"
              :series="competeGraphStack.series"
            />
          </vx-card>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vx-card title="Retailers">
            <div slot="no-body" class="mt-4">
              <vs-table pagination max-items="5" search :data="dashboard.trend">
                <template slot="thead">
                  <vs-th>Brand</vs-th>
                  <vs-th>Assort Match</vs-th>
                  <vs-th>SKUs</vs-th>
                  <!-- <vs-th>Category</vs-th>
                  <vs-th>Deptartment</vs-th> -->
                  <vs-th
                    :key="indexth"
                    v-for="(th, indexth) in prodDistLabels">{{th}}</vs-th>
                  <vs-th>Monitor</vs-th>
                  <vs-th>Last Scan</vs-th>
                  <vs-th>Actions</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr
                    :state="tr.status ? '' : 'dark'"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].brand">
                      <span>{{data[indextr].brand}}</span>
                    </vs-td>
                    <vs-td :data="data[indextr].similarity">
                      <span>{{(data[indextr].similarity > 1 ? 1 : data[indextr].similarity) | numFormat('0 %')}}</span>
                      <vs-progress
                        :percent="data[indextr].similarity*100"
                        :color="getSimilarityColor(data[indextr].similarity*100)"
                      ></vs-progress>
                    </vs-td>
                    <vs-td :data="data[indextr].totalMatchUnits">
                      <span># {{(data[indextr].similarity > 1 ? (dashboard.overview.trend[0].data[dashboard.overview.trend[0].data.length -1]) : data[indextr].totalMatchUnits)}}</span>
                    </vs-td>
                    <!-- <vs-td :data="0">
                      <span># 0</span>
                    </vs-td>
                    <vs-td :data="0">
                      <span># 0</span>
                    </vs-td> -->
                    <vs-td 
                      :key="indextd"
                      v-for="(td, indextd) in fixProductDistribute(data[indextr].productDistribute)"
                      :data="td">
                      <span v-if="(td && td.share !== -1)">{{td.share/100 | numFormat('0 %')}}</span>
                      <span v-else> - </span>
                      <vs-progress
                        v-if="(td && td.share !== -1)"
                        :percent="(td ? td.share : 0)"
                        :color="getSimilarityColor((td ? td.share : 0), 'primary')"
                      ></vs-progress>
                    </vs-td>
                    
                    <!-- <vs-td :data="data[indextr].competeIndex">
                      <span class="flex items-center px-2 py-1 rounded">
                        <div
                          class="h-3 w-3 rounded-full mr-2"
                          :class="'bg-' + getCompeteLevelColor(data[indextr].competeIndex ? data[indextr].competeIndex : 'High')"
                        ></div>
                        {{data[indextr].competeIndex ? data[indextr].competeIndex : 'High'}}
                      </span>
                    </vs-td>-->
                    <vs-td :data="data[indextr].scan">
                      <span>{{data[indextr].scan}}</span>
                    </vs-td>
                    <vs-td :data="data[indextr].lastScan">
                      <span>{{ data[indextr].lastscan | dateParse('YYYY-MM-DDTHH:mm:ss') | dateFormat('D MMM YYYY, HH : mm') }}</span>
                    </vs-td>
                    <vs-td>
                      <div class="vx-col w-full flex sm:w-auto ml-auto mt-2 sm:mt-0 justify-end">
                        <vs-button
                          radius
                          :color="data[indextr].status ? 'danger' : 'success'"
                          type="border"
                          icon-pack="feather"
                          :icon="data[indextr].status ? 'icon-pause' : 'icon-play'"
                          size="small"
                          @click="(data[indextr].status = !data[indextr].status), viewDetails()"
                        ></vs-button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <div>
      <!-- <vs-popup background-color="rgba(255,255,255,.6)" class="" title="Priced the Highest" :active.sync="priceGapHighPop">
        <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
      </vs-popup>
      <vs-popup background-color="rgba(255,255,255,.6)" class="" title="Priced the Lowest" :active.sync="priceGapLowPop">
        <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
      </vs-popup> -->
      <vs-popup
        background-color="rgba(255,255,255,.6)"
        class
        :title="filter.label"
        :active.sync="priceGapPop"
      >
        <ExportGrid :filter="filter" :key="filter.type"></ExportGrid>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/app/shared/components/statistics-cards/StatisticsCardLine.vue";
import ChangeTimeDurationDropdown from "@/app/shared/components/ChangeTimeDurationDropdown.vue";

import ExportGrid from "./ExportGrid.vue";

import analyticsData from "./analyticsData.js";
import { appAnalyze } from '@/app/shared/services';
import { actionsTypes } from "../shared/state";

import appConfig from "@/../appConfig.js";

const chartColors = appConfig.chart.colors;

export default {
  props: {
    // artefact: { type: Object, required: true }
  },
  data() {
    return {
      isNavOpen: false,
      type: "all",
      activeSearch: null,
      filter: {
        type: ''
      },
      filterReset: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7
      },
      wasSidebarOpen: null,
      colors: appConfig.colors,

      payload: {
        tags: [],
        dateRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        query: "",
        mode: "quantity",
        type: "DASH",
        res: {}
      },
      isLoading: false,
      analyticsData: analyticsData,
      activeSkus: 0,
      prodDistLabels: [],
      defaultProdDists: [],

      competeGraph: {
        series: [
          {
            data: []
          }
        ],
        chartOptions: {
          chart: {
            height: 330,
            type: "bar",
            toolbar: { show: false }
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 100
            }
          },
          plotOptions: {
            bar: {
              // barHeight: '100%',
              distributed: true,
              horizontal: true,
              dataLabels: {
                position: "right"
              }
            }
          },
          colors: [chartColors[0]],
          fill: {
            type: "gradient",
            gradient: {
              // enabled: true,
              shade: "dark",
              inverseColors: true,
              gradientToColors: [chartColors[0]],
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 0.5,
              stops: [0, 100, 100, 100],
            }
          },
          dataLabels: {
            enabled: true,
            textAnchor: "start",
            style: {
              colors: ["#626262"]
            },
            formatter: function(val, opt) {
              return (
                "- " + opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
              );
            },
            dropShadow: {
              // enabled: true
            }
          },
          stroke: {
            show: false,
            width: 2,
            colors: ["transparent"]
          },
          xaxis: {
            labels: {
              show: false,
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false
            },
            categories: []
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          title: {
            // text: 'Custom DataLabels',
            // align: 'center',
            // floating: true
          },
          subtitle: {
            // text: 'Category Names as DataLabels inside bars',
            // align: 'center',
          },
          tooltip: {
            theme: "light",
            x: {
              show: true
            },
            y: {
              title: {
                formatter: function() {
                  return "Competitive SKUs ";
                }
              }
            }
          }
        }
      },

      realtimeTrendChart: {
        series: [
          {
            data: this.generateDayWiseTimeSeries(
              new Date("11 Feb 2017").getTime(),
              185,
              {
                min: 30,
                max: 90
              }
            )
          }
        ],
        chartOptionsArea: {
          chart: {
            id: "chartArea",
            toolbar: {
              autoSelected: "pan",
              show: false
            }
          },
          colors: chartColors,
          stroke: {
            show: false,
            width: 2,
            colors: ["transparent"]
          },
          dataLabels: {
            enabled: false
          },
          fill: {
            opacity: 1
          },
          markers: {
            size: 0
          },
          xaxis: {
            type: "datetime"
          }
        },
        chartOptionsBrush: {
          chart: {
            id: "chartBrush",
            brush: {
              target: "chartArea",
              enabled: true
            },
            selection: {
              enabled: true,
              xaxis: {
                min: new Date("19 Jun 2017").getTime(),
                max: new Date("14 Aug 2017").getTime()
              }
            }
          },
          colors: chartColors,
          fill: {
            type: "gradient",
            gradient: {
              opacityFrom: 0.91,
              opacityTo: 0.1
            }
          },
          xaxis: {
            type: "datetime",
            tooltip: {
              enabled: false
            }
          },
          yaxis: {
            tickAmount: 2
          }
        }
      },

      // realtimeTrendChart: {
      //   series: [{
      //     data: this.realtimeData.slice()
      //   }],
      //   chartOptionsArea: {
      //     chart: {
      //       id: 'chartArea',
      //       animations: {
      //         enabled: true,
      //         easing: 'linear',
      //         dynamicAnimation: {
      //           speed: 1000
      //         }
      //       },
      //       toolbar: {
      //         autoSelected: 'pan',
      //         show: false
      //       }
      //     },
      //     colors: ['#546E7A'],
      //     stroke: {
      //       width: 3
      //     },
      //     dataLabels: {
      //       enabled: false
      //     },
      //     fill: {
      //       opacity: 1,
      //     },
      //     markers: {
      //       size: 0
      //     },
      //     xaxis: {
      //       type: 'datetime',
      //       range: 777600000,
      //     }
      //   },
      //   chartOptionsBrush: {
      //     chart: {
      //       id: 'chartBrush',
      //       brush: {
      //         target: 'chartArea',
      //         enabled: true
      //       },
      //       selection: {
      //         enabled: true,
      //         xaxis: {
      //           min: new Date('19 Jun 2017').getTime(),
      //           max: new Date('14 Aug 2017').getTime()
      //         }
      //       },
      //     },
      //     colors: ['#008FFB'],
      //     fill: {
      //       type: 'gradient',
      //       gradient: {
      //         opacityFrom: 0.91,
      //         opacityTo: 0.1,
      //       }
      //     },
      //     xaxis: {
      //       type: 'datetime',
      //       tooltip: {
      //         enabled: false
      //       }
      //     },
      //     yaxis: {
      //       tickAmount: 2
      //     }
      //   }
      // }

      competeGraphStack: {
        series: [{
            name: 'Priced Low',
            data: [10, 24, 10]
          }, {
            name: 'Priced Similar',
            data: [0, 0, 0]
          }, {
            name: 'Priced High',
            data: [24, 4, 12]
          }
        ],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 330,
            stacked: true,
            toolbar: {
              show: false
            }
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 100
            }
          },
          plotOptions: {
            bar: {
              horizontal: true
            },
          },
          // colors: chartColors,
          stroke: {
            width: 1,
            colors: ['#fff']
          },
          xaxis: {
            categories: ['Walmart', 'Amazon', 'Kroger'],
            labels: {
              formatter: function (val) {
                return val > 999 || val < -999
                  ? (val / 1000).toFixed(1) + "k"
                  : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
              }
            },
            axisBorder: {
              show: false
            },
          },
          yaxis: {
            title: {
              text: undefined
            },
            axisBorder: {
              show: false
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val > 999 || val < -999
                  ? (val / 1000).toFixed(1) + "k"
                  : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
              }
            }
          },
          fill: {
            opacity: 1
          },
          legend: {
            position: 'top',
            horizontalAlign: 'right',
            offsetX: 40
          }
        }
      },
      competeDeltaShare : [{
          name: 'Walmart',
          data: [28, 0, 4],
          stat: [32, 0, 0]

        }, {
          name: 'Amazon',
          data: [10, 0, 5],
          stat: [28, 0, 0]
        },{
          name: 'Kroger',
          data: [10, 0, 24],
          stat: [22, 0, 0]
        }
      ],
      competePriceGap : {
        hpriced: 0,
        lpriced: 0,
        share: []
      },
      priceGapPop: false,

      activeSKUs: 0
    }
  },
  methods: {
    init() {
      this.$store.dispatch(
        "competer/" + actionsTypes.FETCH_COMPETER_ARTEFACT,
        this.payload
      );
    },

    generateDayWiseTimeSeries(baseval, count, yrange) {
      var i = 0;
      var series = [];
      while (i < count) {
        var x = baseval;
        var y =
          Math.floor(Math.random() * (yrange.max - yrange.min + 1)) +
          yrange.min;

        series.push([x, y]);
        baseval += 86400000;
        i++;
      }

      // console.log(series)
      return series;
    },
    openStock(view) {
      appAnalyze.pendoTrack("Product List", {});
      this.$router.push("/competer/stock"+(view ? '/'+view : ''));
    },
    openStockNew(view, filter) {
      appAnalyze.pendoTrack("Product List", {});
      this.$router.push({path: '/competer/stock'+(view ? '/'+view : ''), query: filter});
    },
    priceGapDetail(type) {
      this.priceGapPop = false;
      if(type === 'high'){
        this.filter = {
          label: 'SKUs Priced the Highest @ '+this.$options.filters.dateFormat(new Date(), 'D MMM YYYY'),
          key: 'cts_high',
          type: type
        }
      } else if(type === 'higher_only'){
        this.filter = {
          label: 'SKUs Priced Higher Only @ '+this.$options.filters.dateFormat(new Date(), 'D MMM YYYY'),
          key: type,
          type: type
        }
      } else if(type === 'higher_plus'){
        this.filter = {
          label: 'SKUs Priced the Highest and Higher @ '+this.$options.filters.dateFormat(new Date(), 'D MMM YYYY'),
          key: type,
          type: type
        }
      } else if(type === 'low'){
        this.filter = {
          label: 'SKUs Priced the Lowest @ '+this.$options.filters.dateFormat(new Date(), 'D MMM YYYY'),
          key: 'cts_low',
          type: type
        }
      } else {
        this.filter = {
          label: 'All SKUs @ '+this.$options.filters.dateFormat(new Date(), 'D MMM YYYY'),
          key: type,
          type: type
        }
      }
      this.priceGapPop = true;
    },
    openInsight() {
      this.$router.push("/competer/explore");
    },
    getCompeteLevelColor(status) {
      if (status == "Medium") return "warning";
      if (status == "Low") return "success";
      if (status == "High") return "danger";
      return "primary";
    },
    getSimilarityColor(num, color) {
      // if (num > 90) return "success";
      // if (num > 70) return "primary";
      // if (num >= 50) return "warning";
      // if (num < 50) return "danger";
      return color ? color : "primary";
    },

    getDayWiseTimeSeries(baseval, count, yrange) {
      var i = 0;
      while (i < count) {
        var x = baseval;
        var y =
          Math.floor(Math.random() * (yrange.max - yrange.min + 1)) +
          yrange.min;

        this.realtimeData.push({
          x,
          y
        });
        this.lastDate = baseval;
        baseval += 86400000;
        i++;
      }
    },
    getNewSeries(baseval, yrange) {
      var newDate = baseval + 86400000;
      this.lastDate = newDate;
      this.realtimeData.push({
        x: newDate,
        y:
          Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min
      });
    },
    resetData() {
      this.realtimeData = this.realtimeData.slice(
        this.realtimeData.length - 10,
        this.realtimeData.length
      );
    },
    intervals() {
      var me = this;
      // window.setInterval(function () {
      //   var yrange = {
      //     min: 10,
      //     max: 90
      //   };
      //   var newDate = this.lastDate + 86400000;
      //   this.lastDate = newDate
      //   this.realtimeData.push({
      //     x: newDate,
      //     y: Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min
      //   })
      //   me.$refs.realtimeChart.updateSeries([{
      //     data: this.realtimeData
      //   }])
      // }, 1000)

      // every 60 seconds, we reset the data to prevent memory leaks
      // window.setInterval(function () {
      //   this.resetData()
      //   me.$refs.realtimeChart.updateSeries([{
      //     data: this.realtimeData
      //   }], false, true)
      // }, 60000)
    },
    similarity(matchUnits) {
      return matchUnits / this.activeSkus;
    },
    mapDashboard() {
      if (
        this.artefact &&
        this.artefact.res &&
        this.artefact.res.trend &&
        this.artefact.res.competition
      ) {
        this.activeSkus = this.artefact.res.overview.trend[1].data[
          this.artefact.res.overview.trend[1].data.length - 1
        ];

        // let competition = this.artefact.res.trend.map(trend => {
        //   var haveEqualId = compete => compete.brand === trend.brand;
        //   var objWithEqualId = this.artefact.res.competition.find(
        //     haveEqualId
        //   );
        //   objWithEqualId.similarity = trend.totalMatchUnits / this.activeSkus;
        //   objWithEqualId.status = true;
        //   return Object.assign({}, trend, objWithEqualId);
        // });

        // this.artefact.res.competition = competition;

        let trend = this.artefact.res.trend.map(trend => {
          trend.similarity = trend.totalMatchUnits / this.activeSkus;
          trend.status = true;
          trend.scan = 'Every Day';
          return trend;
        });

        this.artefact.res.trend = trend;

        if(this.artefact.res.delta && !this.artefact.res.delta.share) {
          this.artefact.res.delta = this.competePriceGap;
        }

        this.competePerform();
        this.productDistribute();
      }
    },
    competePerform() {
      let trend = [];
      let chartHeightIndex = 200;

      trend = Object.assign(trend, this.artefact.res.trend);

      trend.sort(function(a, b) {
        return b.competitiveskus - a.competitiveskus;
      });

      // trend = trend.slice(1, 3);

      let xCat = trend.map(d => d.brand);
      let series = [];
      let sData = {
        data: []
      };
      sData.data = trend.map(d => Number(d.competitiveskus));

      series.push(sData);

      this.competeGraph.chartOptions = {
        ...this.competeGraph.chartOptions,
        ...{
          chart: {
            height: chartHeightIndex * Math.ceil(trend.length / 15),
            type: "bar",
            toolbar: { show: false }
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 100
            }
          },
          plotOptions: {
            bar: {
              // barHeight: '100%',
              distributed: true,
              horizontal: true,
              dataLabels: {
                position: "right"
              }
            }
          },
          legend: {
            show: false
          },
          xaxis: {
            labels: {
              show: false,
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false
            },
            categories: xCat
          }
        }
      };

      this.competeGraph.series = series;

      return this.competeGraph;
    },
    productDistribute() {
      this.prodDistLabels = [];
      let trend = [];
      let chartHeightIndex = 200;

      trend = Object.assign(trend, this.artefact.res.trend);

      trend.sort(function(a, b) {
        return b.competitiveskus - a.competitiveskus;
      });

      // trend = trend.slice(1, 3);

      let xCat = [];
      for(let t of trend) {
        if(t.productDistribute) { 
          xCat.push(t.brand);
        }
      }
  
      let series = [];

      let pdMap = new Map();

      for(let t of trend) {
        if(t.productDistribute && xCat.includes(t.brand)) {
          for(let index = 0; index < t.productDistribute.length; index++) {
            let pd = t.productDistribute[index]
            let label = pd.label+'_'+index;
            pdMap.set(label, pd.label)
          }
          break;
        }
      }

      for(let label of pdMap.keys()) {
        this.prodDistLabels.push(pdMap.get(label));
        let pdist = []
        for(let t of trend) {
          if(t.productDistribute && xCat.includes(t.brand)) {
            for(let index = 0; index < t.productDistribute.length; index++) {
              let pd = t.productDistribute[index]
              let pdlabel = pd.label+'_'+index;
              if(pdlabel === label){
                pdist.push(pd);
                break;
              }
            }
          } else {
            // pdist.push({'label': label, 'share': 0, 'count': 0});
          }
        }

        let sData = {
          name: pdMap.get(label),
          data: pdist.map(d => (d.count !== 0 ? Number(d.count) : null))
        };

        series.push(sData);
      }


      this.competeGraphStack.chartOptions = {
        ...this.competeGraphStack.chartOptions,
        ...{
          chart: {
            type: 'bar',
            height: 330,
            stacked: true,
            toolbar: {
              show: false
            },
            events: {
              dataPointSelection: (e, chartContext, config) => {
                // you can call Vue methods now as "this" will point to the Vue instance when you use ES6 arrow function
                let series = config.w.config.series
                let filter = {
                  biz: config.w.config.xaxis.categories[config.dataPointIndex].trim().replace(/ /g, "_").toLowerCase(), 
                  tag: series[config.seriesIndex] ? series[config.seriesIndex].name.trim().replace(/ /g, "_").toLowerCase() : 'priced_low', 
                  mode: series[config.seriesIndex] ? series[config.seriesIndex].name.trim().replace(/ /g, "_").toLowerCase() : 'priced_low'
                }

                this.openStockNew('item-list-view', filter)
              }
            }
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 100
            }
          },
          plotOptions: {
            bar: {
              horizontal: true
            },
          },
          // colors: chartColors,
          stroke: {
            width: 1,
            colors: ['#fff']
          },
          xaxis: {
            categories: xCat,
            labels: {
              formatter: function (val) {
                return val > 999 || val < -999
                  ? (val / 1000).toFixed(1) + "k"
                  : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
              }
            },
            axisBorder: {
              show: false
            },
          },
          yaxis: {
            title: {
              text: undefined
            },
            axisBorder: {
              show: false
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val > 999 || val < -999
                  ? (val / 1000).toFixed(1) + "k"
                  : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
              }
            }
          },
          fill: {
            opacity: 1
          },
          legend: {
            position: 'top',
            horizontalAlign: 'right',
            offsetX: 40
          }
        }
      };

      this.competeGraphStack.series = series;

      return this.competeGraphStack;
    },
    fixProductDistribute(actual) {
      if(actual) {
        return actual;
      }
      else {
        let productDistribute = [];
        for(let label of this.prodDistLabels) {
          productDistribute.push({'label': label, 'share': -1, 'count': -1});
        }
        return productDistribute;
      }
    },
    viewDetails() {
      this.$vs.notify({
        time: 2500,
        title: "Info",
        text: "Feature: TODO",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });
    },
    getOrderStatusColor(status) {
      if(status == 'on_hold') return "warning"
      if(status == 'delivered') return "success"
      if(status == 'canceled') return "danger"
      return "primary"
    },
    getPopularityColor(num) {
      if(num > 90) return "success"
      if(num >70) return "primary"
      if(num >= 50) return "warning"
      if(num < 50) return "danger"
      return "primary"
    },
    getPricedSKUs(type, high, low) {
      let activeSkus = this.dashboard.overview.trend[1].data[this.dashboard.overview.trend[1].data.length -1] 
      if(type === 'higher_only') {
        return activeSkus - (Number(high) + Number(low));
      }
      if(type === 'higher_plus') {
        return activeSkus - Number(low);
      }
    },

  },
  computed: {
    dashboard() {
      this.mapDashboard();

      return this.artefact && this.artefact.res
        ? this.artefact.res
        : {};
    },
    deltaShare() {
      let share = (this.artefact && this.artefact.res && this.artefact.res.delta) ? this.artefact.res.delta.share : null;
      if(share) {
        share.sort(function (x, y) {
          let xLabelParts = x.label.split('-')
          let yLabelParts = y.label.split('-')
          return isNaN(yLabelParts[0])  ? -1 : xLabelParts[0] - yLabelParts[0];
        });
      }
      
      return share;
    },
    deltaShareTranspose() {
      let label = this.deltaShare.map(d => d.label)
      let high = this.deltaShare.map(d => d.high)
      let low = this.deltaShare.map(d => d.low)
      let hamp = this.deltaShare.map(d => d.hamp)
      let lamp = this.deltaShare.map(d => d.lamp)

      let transposedData = {
        label: label,
        high: high,
        low: low,
        hamp: hamp,
        lamp: lamp
      }
      
      return transposedData;
    },

    ...mapGetters({
      artefact: "competer/artefact"
    })
  },
  mounted() {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    this.init();
    this.filterReset = true;

    this.$store.watch(
      (state, getters) => getters["competer/isLoading"],
      (newValue, oldValue) => {
        this.isLoading = newValue;
        if (this.isLoading) {
          this.$vs.loading({
            // background: this.backgroundLoading,
            // color: this.colorLoading,
            // container: "#analyze-app",
            // scale: 0.45,
            type: "radius"
          });
        }

        if (!this.isLoading) {
          this.$vs.loading.close();
          // this.$vs.loading.close("#analyze-app > .con-vs-loading");
        }
      }
    );

  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
  watch: {
    "$store.state.AppScopeTrack"(val) {
      this.init();
    }
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    VuePerfectScrollbar,
    ChangeTimeDurationDropdown,
    ExportGrid
  }
};
</script>

<style lang="scss">
#trend {
}
</style>
